import { NavigationLink } from '@misc/constants';

export const navigation: NavigationLink[] = [
  { label: 'Dashboard', url: ['', 'dashboard'], icon: 'dashboard' },
  { label: 'Users', url: ['', 'users'], icon: 'supervised_user_circle' },
  { label: 'Posts', url: ['', 'posts'], icon: 'reorder' },
  { label: 'Cities', url: ['', 'cities'], icon: 'location_city' },
  { label: 'Settings', url: ['', 'settings'], icon: 'settings_applications' }
];
